export default __webpack_public_path__ + "static/media/BA5.978d99d2.jpg";